/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Store/StoreLocationService',[
    'jquery',
    'global/all',
    'modules/User/Users'
], function ($, Roc, Users) {
    'use strict';

    var apiUrl = window.RocConfig.api.baseRocApiUrl;
    var defaultStoreCookieName = "default_store_id";
    var defaultStoreId = null;

    function searchByZip(productId, zip) {
        var request = {
            productId: productId,
            zipCode: zip
        };

        Roc.Logger.info('StoreLocationService -> searchByZip', request);
        return $.ajax({
            url: apiUrl + '/api/storelocation/search/zip',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(request)
        });
    }

    function searchByGeolocation(productId, geolocation) {
        var request = {
            productId: productId,
            location: geolocation
        };
        
        Roc.Logger.info('StoreLocationService -> searchByGeolocation', request);

        return $.ajax({
            url: apiUrl + '/api/storelocation/search/geolocation',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(request)
        });
    }

    function getDefaultStoreId() {
        var deferred = $.Deferred();
        if (defaultStoreId) {
            Roc.Logger.info('StoreLocationService -> getDefaultStoreId() getting id from cache...');
            deferred.resolve(defaultStoreId);
        }
        else if (Users.isLoggedIn()) {
            Roc.Logger.info('StoreLocationService -> getDefaultStoreId() getting id from api...');
            $.ajax({
                url: apiUrl + '/api/storelocation/default',
                type: 'GET',
                contentType: 'application/json',
                dataType: 'json',
                success: function (storeId) {
                    defaultStoreId = storeId;
                    deferred.resolve(storeId);
                },
                error: function () {
                    defaultStoreId = null;
                    deferred.reject();
                }
            });
        } else {
            Roc.Logger.info('StoreLocationService -> getDefaultStoreId() getting id from cookies...');
            var storeId = Roc.Core.readCookie(defaultStoreCookieName);
            if (storeId) {
                defaultStoreId = storeId;
                deferred.resolve(storeId);
            } else {
                defaultStoreId = null;
                deferred.reject();
            }
        }
        return deferred.promise();
    }

    function setDefaultStoreId(storeId) {
        defaultStoreId = storeId;
        if (Users.isLoggedIn()) {
            Roc.Logger.info('StoreLocationService -> setDefaultStoreId: sending id to api...');
            return $.ajax({
                url: apiUrl + '/api/storelocation/default/' + storeId,
                type: 'PUT',
                contentType: 'application/json'
            });
        } else {
            var deferred = $.Deferred();
            // api call
            Roc.Logger.info('StoreLocationService -> setDefaultStoreId: saving store id in cookies...');
            Roc.Core.createCookie(defaultStoreCookieName, storeId, 15);
            deferred.resolve();
            return deferred.promise();
        }
    }

    function seachByLocationGroup(sku, locationCode) {
        Roc.Logger.info('StoreLocationService -> searchByZip', { sku: sku, locationCode: locationCode });
        return $.ajax({
            url: apiUrl + '/api/productdelivery/options/pickupLocations',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({ sku: sku, locationCode: locationCode })
        });
    }

    var StoreLocationService = {
        searchByZip: searchByZip,
        searchByGeolocation: searchByGeolocation,
        setDefaultStoreId: setDefaultStoreId,
        getDefaultStoreId: getDefaultStoreId,
        seachByLocationGroup: seachByLocationGroup
    };

    Roc.Logger.debug('StoreLocationService.js Loaded:', StoreLocationService);

    return StoreLocationService;
});
